import React, { useEffect } from 'react';
import { Button, Form } from 'antd';
import '../../styles/index.css';
import {
  NotificationError,
  NotificationSucces,
} from '../common/common-componnets/Notifications';
import FormFieldRender from '../FormRender/FormFieldRender';
import { FORM_FIELD } from '../../utilities/enums';
import {
  EkspertizaProps,
  useUpdateEkspertizaMutation,
} from '../../redux/features/pjesemarres/pjesemarres-api';
import { useAuth } from '../../hooks/use-auth';

const FushaEkspertizes = () => {
  const [form] = Form.useForm();
  const [updateEkspertiza] = useUpdateEkspertizaMutation();
  const { data: loggedInUser, refetch } = useAuth();

  useEffect(() => {
    if (loggedInUser?.ekspertiza) {
      form.setFieldsValue({
        ekspertiza: loggedInUser.ekspertiza,
      });
    }
  }, [loggedInUser?.ekspertiza]);

  const handleSubmit = ({ ekspertiza }: EkspertizaProps) => {
    updateEkspertiza({
      ekspertiza,
    })
      .unwrap()
      .then(() => {
        NotificationSucces('Fusha e ekspertizes u ruajt me sukses');
        refetch();
      })
      .catch(error => {
        NotificationError(error.data.message);
      });
  };

  const fushaEkspertizesField = {
    label: 'Fusha e Ekspertizes',
    name: 'ekspertiza',
    type: FORM_FIELD.TEXT_AREA,
    placeholder: 'Vendosni fushen e ekspertizes',
    otherprops: {
      className: 'h-12',
    },
    rules: [
      {
        required: true,
        message: 'Ju lutem vendosni fushen e ekspertizes!',
      },
    ],
  };

  return (
    <Form
      form={form}
      requiredMark={false}
      className="m-3"
      name="fushaEkspertizes"
      onFinish={handleSubmit}
      layout="vertical"
      initialValues={{
        ekspertiza: loggedInUser?.ekspertiza || '',
      }}
    >
      <div className="flex w-[100%] flex-col">
        <div className="input-with-placeholder my-6 border">
          <span
            className="form-item-label font-sans text-sm font-medium tracking-wide"
            style={{
              color: '#003666',
            }}
          >
            {fushaEkspertizesField.label}
          </span>
          <FormFieldRender data={fushaEkspertizesField} />
        </div>
      </div>

      <div className="flex justify-end">
        <Button
          name="Submit"
          className="submitButton block h-11 w-full rounded text-base font-semibold text-white"
          htmlType="submit"
          style={{ backgroundColor: '#FF731D' }}
        >
          Ruaj
        </Button>
      </div>
    </Form>
  );
};

export default FushaEkspertizes;
